/**
 * Module-level pub/sub for "a comment was resolved (replied) this session",
 * mirroring commentScoreSessionManager's pattern for cross-tree signals.
 *
 * The comment-details dialog renders outside every list's
 * EngagementCoordinationProvider, so when a reply is sent from it, the list
 * can't learn about the resolution through the usual card callbacks. The
 * reply submit strategy triggers this event instead, and each mounted
 * comments list subscribes to mark the card locally resolved — greying it
 * without touching list membership (session-resolution semantics).
 */

type CommentResolvedListener = (commentId: string) => void

const listeners = new Set<CommentResolvedListener>()

export const subscribeToCommentResolvedEvents = (
  listener: CommentResolvedListener,
): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const triggerCommentResolved = (commentId: string): void => {
  listeners.forEach((listener) => listener(commentId))
}
